var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertBuilding01 = function SvgAlertBuilding01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_building-01_svg2__a",
    x1: -26.38,
    x2: 154.04,
    y1: 148.57,
    y2: -23.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__b",
    x1: 3.51,
    x2: 183.94,
    y1: 179.86,
    y2: 7.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__c",
    x1: 28.57,
    x2: 209,
    y1: 206.09,
    y2: 33.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__d",
    x1: 34.73,
    x2: 215.15,
    y1: 212.53,
    y2: 40.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__e",
    x1: 40.89,
    x2: 221.31,
    y1: 218.98,
    y2: 46.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__f",
    x1: 5.33,
    x2: 185.75,
    y1: 181.76,
    y2: 9.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_building-01_svg2__a",
    id: "alert_building-01_svg2__g",
    x1: 15,
    x2: 195.42,
    y1: 191.88,
    y2: 19.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.58 122.58H87.1c1.78 0 3.23-1.44 3.23-3.23V22.58c0-1.78-1.44-3.23-3.23-3.23H22.58c-1.78 0-3.23 1.44-3.23 3.23v96.77c0 1.78 1.44 3.23 3.23 3.23m3.23-6.45v-12.9h58.06v12.9zm58.06-51.61v12.9H25.81v-12.9zm-58.06-6.46v-12.9h58.06v12.9zm58.06 25.81v12.9H25.81v-12.9zm0-58.06v12.9H25.81v-12.9z",
    style: {
      fill: "url(#alert_building-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.95 58.56 168.9 4.48c-2.34-4.2-7.64-5.71-11.85-3.37a8.73 8.73 0 0 0-3.37 3.37l-13.64 24.55h-30.36V3.23c0-1.79-1.45-3.23-3.23-3.23H3.23C1.44 0 0 1.44 0 3.23v193.55c0 1.78 1.44 3.23 3.23 3.23h167.74c1.78 0 3.23-1.44 3.23-3.23V70.97h17.45c4.61 0 8.35-3.73 8.35-8.34 0-1.42-.36-2.82-1.05-4.06Zm-62.5-23.08-3.58 6.45h-23.19v-6.45zm11.94 45.17h-38.71v-12.9h14.71a8.31 8.31 0 0 0 6.55 3.23h17.45v9.68Zm0 6.45V100h-38.71V87.1zm-24.76-28.54c-.45.85-.75 1.78-.88 2.74h-13.07V48.4h19.61l-5.65 10.17ZM74.19 193.55H58.06v-51.61h16.13zm-22.58 0H35.48v-51.61h16.13zm51.62 0H80.65v-54.84c0-1.78-1.44-3.23-3.23-3.23H32.26c-1.78 0-3.23 1.44-3.23 3.23v54.84H6.45V6.45h96.77v187.1Zm6.45-51.61h25.81v51.61h-25.81zm58.06 51.61h-25.81v-54.84c0-1.78-1.44-3.23-3.23-3.23h-29.03v-29.03h41.94c1.78 0 3.23-1.44 3.23-3.23V70.96h12.9v122.58Zm23.91-129.03h-60.72a1.897 1.897 0 0 1-1.66-2.82l30.05-54.08a2.253 2.253 0 0 1 3.07-.87c.36.2.67.5.87.87l30.05 54.09a1.9 1.9 0 0 1-1.66 2.82Z",
    style: {
      fill: "url(#alert_building-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13 116.13h6.45v6.45h-6.45z",
    style: {
      fill: "url(#alert_building-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.03 116.13h6.45v6.45h-6.45z",
    style: {
      fill: "url(#alert_building-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93 116.13h6.45v6.45h-6.45z",
    style: {
      fill: "url(#alert_building-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.96 45.16c-1.34 0-2.42-1.08-2.42-2.42V23.39c0-1.34 1.08-2.42 2.42-2.42s2.42 1.08 2.42 2.42v19.35c0 1.34-1.08 2.42-2.42 2.42",
    style: {
      fill: "url(#alert_building-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.96 54.84c-.3 0-.63-.05-.92-.19-.29-.1-.58-.29-.77-.53a1.65 1.65 0 0 1-.53-.77c-.15-.29-.19-.63-.19-.92 0-.63.24-1.26.72-1.69.63-.68 1.7-.92 2.61-.53.3.1.58.29.77.53.49.44.73 1.06.73 1.69 0 .34-.05.63-.19.92-.1.29-.3.58-.53.77-.44.48-1.06.73-1.69.73Z",
    style: {
      fill: "url(#alert_building-01_svg2__g)"
    }
  }));
};
export default SvgAlertBuilding01;